import script from "./StakingView.vue?vue&type=script&setup=true&lang=js"
export * from "./StakingView.vue?vue&type=script&setup=true&lang=js"

import "./StakingView.vue?vue&type=style&index=0&id=43ef4dbd&lang=css"

const __exports__ = script;

export default __exports__